module.exports = __webpack_public_path__ + "static/media/arrowBlackSend@3x.161d4826.png";